import { useTheme } from '@mui/material/styles';

const Logo = (props) => {
  const theme = useTheme();
  const fillColor = theme.palette.primary.main;

  return (
    <img
      alt="Logo"
      src="/static/images/foodlytik.png"
      height={props.heightlogo ? props.heightlogo : "80px"}
      {...props}
    />
  );
};

export default Logo;
